
export default {
  props: {
    data: {type: Object, required: true}
  },
  computed: {
    type() {
      return this.data.type
    },
    url(){
      return this.data.url
    },
    name() {
      return this.data.name
    },
    logo() {
      return this.data.logo
    },
    file_icon () {
      return this.type === 'file' && !this.logo
    },
    favicon_src() {
      if (this.url?.includes('apollo.io')) {
        return 'assets/apollo.svg'
      }
      if (this.url?.includes('bing.com')) {
        return 'assets/bing.png'
      }
      if (this.logo) {
        return this.logo
      }
      return '/assets/icons/cube-02.svg'
    }
  }
}
